import { ActionContext, ActionTree } from 'vuex'

import { BrandSkuState, RootState } from '@/types/store'

import { getBrandSkus, suggestBrandSkus } from '@/api/brand-skus'

type Context = ActionContext<BrandSkuState, RootState>

export interface BrandSkuActions extends ActionTree<BrandSkuState, RootState> {
  getBrandSkus: (
    ctx: Context,
    {
      name,
      code,
      categoryId,
      jicsfClassificationCds,
    }: {
      name: string
      code?: string
      categoryId?: number
      jicsfClassificationCds?: number[]
    },
  ) => Promise<void>
}

export const actions: ActionTree<BrandSkuState, RootState> = {
  async getBrandSkus(
    { commit },
    {
      name,
      code,
      categoryId,
      jicsfClassificationCds,
    }: {
      name: string
      code: string
      categoryId: number
      jicsfClassificationCds: number[]
    },
  ): Promise<void> {
    commit('brandSkusLoaded', [])
    commit('brandSkusLoadStart', true)
    const brandSkus = await getBrandSkus(
      name,
      code,
      categoryId,
      jicsfClassificationCds,
    )
    commit('brandSkusLoaded', brandSkus)
  },
  async suggestBrandSkus(
    { commit },
    {
      name,
      code,
      categoryId,
    }: {
      name: string
      code: string
      categoryId: number
    },
  ): Promise<void> {
    commit('brandSkusLoaded', [])
    commit('brandSkusLoadStart', true)
    const brandSkus = await suggestBrandSkus(name, code, categoryId)
    commit('brandSkusLoaded', brandSkus)
  },
  reset({ commit }): void {
    commit('brandSkusLoaded', [])
  },
}
